import { useLayoutStyles } from '@/components/blocks/hooks'
import { BlockRenderer } from '../../BlockRenderer'
import type { BlockVisualProps } from '../../Types'
import type { RowBlock } from '@/types/blocks/layout/Row'
import type { PlayBlock_Union } from '@/types/blocks'
import './row-visual.css'

// Extended type for blocks with resolved children (runtime property added by BlockResolutionService)
type RowBlockWithChildren = RowBlock & { __resolved_children?: PlayBlock_Union[] }

export function RowVisual({ block }: BlockVisualProps) {
	// Call hooks unconditionally (React rules of hooks)
	const rowBlock = block as RowBlockWithChildren
	const layoutStyles = useLayoutStyles(rowBlock.properties?.layout, 'row')

	// Type guard - return early AFTER hooks
	if (block.type !== 'row') return null

	return (
		<div className="row-visual" style={layoutStyles} data-block-id={rowBlock.id}>
			{rowBlock.__resolved_children?.map((child) => <BlockRenderer key={child.id} block={child} />)}
		</div>
	)
}
